import React, { Component, Fragment } from 'react';
import { Card } from 'antd';
import { withTranslation } from "react-i18next";
import { PageListComponent, HeaderListComponent, ListComponent } from "../../../common/component/Index";

const pageSize = 2;
const sampleItems = [
    { id: 'item-1', itemCode: 'I001', itemName: 'Soy Sauce', itemPrice: '1.00' },
    { id: 'item-2', itemCode: 'I002', itemName: 'Chili Sauce', itemPrice: '1.50' },
    { id: 'item-3', itemCode: 'I003', itemName: 'Ketchup', itemPrice: '1.00' },
    { id: 'item-4', itemCode: 'I004', itemName: 'Mayonnaise', itemPrice: '1.20' },
];

class CondimentSetMenu extends Component {
    render() {
        const { t, match, location } = this.props;
        const condimentName = location?.state?.condimentName || `Condiment ${match.params.id}`;
        const columns = [
            { title: "Items code", dataIndex: 'itemCode', key: 'itemCode' },
            { title: "Items name", dataIndex: 'itemName', key: 'itemName' },
            { title: "Items price", dataIndex: 'itemPrice', key: 'itemPrice' },
        ];

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={match.path}
                        titleHeader={t('navigation.condiment')}
                        extraBreadcrumbs={[{ title: condimentName }]}
                    />
                    <Card bordered={false}>
                        <ListComponent
                            tableKey="condiment-items-list"
                            classChildren="p-0"
                            classParent="m-0"
                            rowKey={(record, index) => record.id || index}
                            dataSource={sampleItems}
                            columns={columns}
                            pagination={{ total: sampleItems.length, totalPage: 1, defaultCurrent: 1, pageSize }}
                        />
                    </Card>
                </PageListComponent>
            </Fragment>
        );
    }
}

export default withTranslation()(CondimentSetMenu);
